import React from "react";
import DetalleCard from "~business/Cards/DetalleCard";
import GalleryWithLightbox from "~styled/gallery/GalleryWithLightBox";
import PhotoIcon from "@mui/icons-material/Photo";
import {
  setFotoFrontalFileName,
  setFotoTraseraFileName,
  setFotoLateralIzquierdoFileName,
  setFotoLateralDerechoFileName,
} from "../actions";
import { useDispatch, useSelector } from "react-redux";
import ItemFileUploaderCard from "~business/Cards/ItemFileUploaderCard";

const title = "Fotos del Vehículo";

type ParteVehiculo =
  "frontal" | "trasera" | "lateralIzquierdo" | "lateralDerecho";

/** El uploader entrega el nombre del archivo subido en `target.value`. */
type UploaderEvent = { target: { value: string } };

const partes = {
  frontal: setFotoFrontalFileName,
  trasera: setFotoTraseraFileName,
  lateralIzquierdo: setFotoLateralIzquierdoFileName,
  lateralDerecho: setFotoLateralDerechoFileName,
};

interface FotosVehiculoCardProps {
  isLoading: boolean;
  editable?: boolean;
  IconHeader?: React.ComponentType<{ className?: string }>;
}

interface SliceFotosVehiculo {
  fotos?: string[] | null;
}

const useReduxSelector = () =>
  useSelector<any, SliceFotosVehiculo>((state) => {
    const detalleSolicitud = state.detalleSolicitudEmisionReducer
      ? state.detalleSolicitudEmisionReducer.detalleSolicitudEmision
      : {};
    return {
      fotos: detalleSolicitud.fotosVehiculo,
    };
  });

const FotosVehiculoCard: React.FC<FotosVehiculoCardProps> = ({
  isLoading,
  IconHeader,
}) => {
  const dispatch = useDispatch();
  const { fotos } = useReduxSelector();

  if (isLoading)
    return (
      <DetalleCard
        isLoading={isLoading}
        title={title}
        IconHeader={IconHeader}
      />
    );

  let photos: {
    src: string;
    thumbnail: string;
    width: number;
    height: number;
  }[] = [];

  if (fotos) {
    photos = fotos.map((fotoVehiculo) => ({
      src: fotoVehiculo,
      thumbnail: fotoVehiculo,
      width: 80,
      height: 80,
    }));
  }

  const handleAdded = (event: unknown, parte: ParteVehiculo) => {
    const action = partes[parte];
    const value = `temp/${(event as UploaderEvent).target.value}`;
    dispatch(
      action({
        value: value,
        valid: true,
      })
    );
  };

  const handleRemoved = (event: unknown, parte: ParteVehiculo) => {
    const action = partes[parte];
    dispatch(
      action({
        value: null,
        valid: false,
      })
    );
  };

  const photosLoaded = photos.length > 0;

  return (
    <DetalleCard isLoading={isLoading} title={title} IconHeader={PhotoIcon}>
      {photosLoaded && <GalleryWithLightbox imagenes={photos} />}
      {!photosLoaded && (
        <>
          <ItemFileUploaderCard
            label={"Parte Frontal"}
            onAdded={(event) => handleAdded(event, "frontal")}
            onRemoved={(event) => handleRemoved(event, "frontal")}
            acceptImage={true}
            acceptPdf={false}
          />
          <ItemFileUploaderCard
            label={"Parte Trasera"}
            onAdded={(event) => handleAdded(event, "trasera")}
            onRemoved={(event) => handleRemoved(event, "trasera")}
            acceptImage={true}
            acceptPdf={false}
          />
          <ItemFileUploaderCard
            label={"Parte Trasera"}
            onAdded={(event) => handleAdded(event, "lateralIzquierdo")}
            onRemoved={(event) => handleRemoved(event, "lateralIzquierdo")}
            acceptImage={true}
            acceptPdf={false}
          />
          <ItemFileUploaderCard
            label={"Parte Trasera"}
            onAdded={(event) => handleAdded(event, "lateralDerecho")}
            onRemoved={(event) => handleRemoved(event, "lateralDerecho")}
            acceptImage={true}
            acceptPdf={false}
          />
        </>
      )}
    </DetalleCard>
  );
};

export default FotosVehiculoCard;
